import { render, staticRenderFns } from "./aggregate.vue?vue&type=template&id=33082ca5&scoped=true&"
import script from "./aggregate.vue?vue&type=script&lang=js&"
export * from "./aggregate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33082ca5",
  null
  
)

export default component.exports